import { useEffect } from 'react';
import { units } from '@ui/css';
import { applyCssDeclarations } from '@utils/css';

function useEmbedBoundaries(ref) {
  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const onUpdate = () => {
      const isPrint = window.matchMedia("print").matches;
      applyCssDeclarations(units.__override({
        vw: isPrint ? undefined : units.px(element.clientWidth / 100)
      }), element);
    };
    onUpdate();
    const observer = new ResizeObserver(onUpdate);
    observer.observe(element);
    window.addEventListener("beforeprint", onUpdate);
    return () => {
      observer.disconnect();
      window.removeEventListener("beforeprint", onUpdate);
    };
  }, [ref]);
}

export { useEmbedBoundaries };
//# sourceMappingURL=hook.embed-boundaries.js.map
